import { jsonName, jsonProperty, Serializable } from "ts-serializable";

class EmailVinculo extends Serializable {


    @jsonName('cpf')
    @jsonProperty(String, null)
    cpf: string = '';

    @jsonName('redirectUrl')
    @jsonProperty(String, null)
    redirectUrl: string = '';

   
}


export default EmailVinculo;